import SprievodnyDokument from '../../../../model/legislativnyMaterial/SprievodnyDokument';
import { ClientStatus } from '../../../../model/ClientStatus';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import {
  fetchSprievodnyDokumentList,
} from '../../../../client/external/evidencnaaplikacia/sprievodnyDokumentListClient';

interface ReturnType {
  sprievodnyDokumentList: Array<SprievodnyDokument>;
  sprievodnyDokumentStatus: ClientStatus;
}

export default (legMaterialuuid: string, stadiumUuid: string): ReturnType => {
  const {
    data: rawSprievodnyDokumentList,
    status: sprievodnyDokumentStatus,
  } = useClientFetch(
    fetchSprievodnyDokumentList,
    [legMaterialuuid, stadiumUuid],
    [legMaterialuuid, stadiumUuid],
  );

  if (rawSprievodnyDokumentList !== null) {
    const sprievodnyDokumentList = rawSprievodnyDokumentList.map((item, index) => ({
      ...item,
      index,
    }));
    return {
      sprievodnyDokumentList,
      sprievodnyDokumentStatus,
    };
  }

  const sprievodnyDokumentList = rawSprievodnyDokumentList;

  return {
    sprievodnyDokumentList,
    sprievodnyDokumentStatus,
  };
};
